module.exports = __webpack_public_path__ + "img/xalor_logo.c66660d2.png";